// App.js
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Testimonials } from "./components/testimonials";
// import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import { BioCalculus } from "./components/Biocalculus"; // Import the BioCalculusPage component
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
// import { Careers } from "./components/Careers";
import Login from "./components/Login";


export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <Router>
      <Navigation />
      <Routes>
        <Route path="/" element={<>
          <Header data={landingPageData.Header} />
          <Features data={landingPageData.Features} />
          <About data={landingPageData.About} />
          <Services data={landingPageData.Services} />
          {/* <Gallery data={landingPageData.Gallery} /> */}
          <Testimonials data={landingPageData.Testimonials} />
          {/* <Team data={landingPageData.Team} /> */}
          <Contact data={landingPageData.Contact} />
        </>} />
        
        <Route path="/login" element={<Login />} />
        <Route path="/biocalculus" element={<BioCalculus />} />
        {/* <Route path="https://careers.redeemertechnologies.com" element={<Careers />} /> */}
        {/* Define other routes here */}
      </Routes>
    </Router>
  );
};

export default App;
